// extracted by mini-css-extract-plugin
export default {"investorList":"investors-dashboard_investorList__i042q","tabView":"investors-dashboard_tabView__CpRuy"};